import * as types from '../constants/ActionTypes';

export function setConfig(config) {
  return {
    type: types.SET_CONFIG,
    payload: config,
  }
}

const appInitialState = {
  isPartialPaymentsAllowed: '',
  isInvoiceOverpaymentAllowed: '',
  cnbsConfig: [],
  config: {
    invoice_table: { columns : []},
  },
  paymentMethods: [],
};

export function appReducer(state = appInitialState, action) {
  switch (action.type) {
    
    case types.UPDATE_PARTIAL_PAYMENT_ALLOWED_FLAG: {
      let val = typeof action.payload !== 'undefined' && (action.payload === 'X' || action.payload === 'R');
      return {...state, isPartialPaymentsAllowed: val};
    }
    
    case types.UPDATE_OVER_PAYMENT_ALLOWED_FLAG: {
      let val = typeof action.payload !== 'undefined' && action.payload === 'X';
      return {...state, isInvoiceOverpaymentAllowed: val};
    }
    
    case types.GET_CUSTOM_DATA_SUCCESS: {
      return {
        ...state, cnbsConfig: action.payload,
      };
    }
    
    case types.SET_CONFIG: {
      return {
        ...state, config: action.payload,
      };
    }
    
    case types.SET_PAYMENT_METHODS: {
      return {...state, paymentMethods: action.payload};
    }

    default:
      return {...state};
  }
}
